import { render } from "./SubmissionMasterDetail.vue?vue&type=template&id=27aa5f52&scoped=true&ts=true"
import script from "./SubmissionMasterDetail.vue?vue&type=script&lang=ts"
export * from "./SubmissionMasterDetail.vue?vue&type=script&lang=ts"

import "./SubmissionMasterDetail.vue?vue&type=style&index=0&id=27aa5f52&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27aa5f52"]])

export default __exports__